import { AsyncJob } from "../../../models/async-job.model";
import { FormInstanceSaveMetrics } from "../../../models/export-import/form-instance-save-metrics.model";
import { FormInstanceOperationsDialog } from "../form-instance-operations.dialog";
import { BaseFormInstanceOperation } from "./base-form-instance-operation"
import { IFormDialogOperation } from "./i-form-dialog-operation";

export class TransitionFormOperation extends BaseFormInstanceOperation implements IFormDialogOperation {

    public dismissButtonTitle: string = 'Close';
    public get title(): string {
        return this.dialog.initInfo.transitionTitle;
    }
    private userLostAccessAfterTransition: boolean;

    constructor(dialog: FormInstanceOperationsDialog) {
        super(dialog)
    }

    public performOperation() {
        this.dialog.asyncFormInstanceSaveService.transitionAndSaveFormInstanceAsync(this.dialog.initInfo.formInstance).then(asyncJob => {
            this.dialog.AsyncJob = asyncJob;

            this.dialog.startMonitoringJob(this.dialog.AsyncJob, this.transitionFormJobCompletedCallback, this.transitionFormJobCompletedCallback);
        });
    }

    public dismissDialog(): void {
        this.dialog.dialogRef.close({ reload: false });
    }

    public disableDismissButton(): boolean {
        return false;
    }

    public get showStartOperationManuallyButton(): boolean {
        return this.dialog.JobCompleted != true;
    };

    // Returns true if in an error state as we just want to close the dialog in that case and not reload the Form
    public get showDismissButton(): boolean {
        return this.dialog.JobCompleted != true || this.dialog.JobErrorOccurred;
    }
    // Returns false if in an error state as we just want to close the dialog in that case and not reload the Form
    public get showDismissWithReloadButton(): boolean {
        return this.dialog.JobCompleted && !this.dialog.JobErrorOccurred;
    }

    public get showGoToSiteHomePageButton(): boolean {
        return false;
    }

    public get UserNoLongerAccessToFormInstance(): boolean {
        return this.userLostAccessAfterTransition;
    }

    public get Status() {
        let status: string = null;

        if (!this.dialog.JobInProgress && this.dialog.AsyncJobInfo == null) {
            status = 'Click OK to proceed, otherwise click Close.';
        } else if (this.dialog.JobInProgress) {
            status = 'Transitioning workflow. Please wait...';
        } else if (!this.dialog.JobErrorOccurred) {
            status = 'Transition Completed. Click "Complete" to reload the Form';
        } else if (this.dialog.JobErrorOccurred) {
            status = 'An error occurred';
        } else {
            status = 'An error occurred';
        }

        return status;
    }

    private transitionFormJobCompletedCallback = (asyncJob: AsyncJob): void => {
        if (this.dialog.jobIsCompleted()) {
            let saveStatus: Object = JSON.parse(asyncJob.stdOut);
            this.dialog.SaveMetrics = new FormInstanceSaveMetrics(saveStatus);
            // now that transition is complete, find out if the user has lost access and set
            // this.userLostAccessAfterTransition
            this.dialog.asyncFormInstanceSaveService.userLostAccessAfterTransition(asyncJob.jobKey).then(x => {
                this.userLostAccessAfterTransition = x;
            });
        } else if ((asyncJob.stdOut != null) && (asyncJob.stdOut.trim() != '')) {
            let saveStatus: Object = JSON.parse(asyncJob.stdOut);
            this.dialog.SaveMetrics = new FormInstanceSaveMetrics(saveStatus);
        } else if (asyncJob.status == 'Completed with error') {

        }
    }
}
